module.exports = __webpack_public_path__ + "img/logo-light.194cea72.svg";